




import {Component, Prop, Vue} from "vue-property-decorator";
import {LadingType} from "@/enums/type";

@Component({
    name: "LadingTypeLabel"
})
export default class extends Vue {
    @Prop({ required: true }) readonly type!: number|undefined;
    LadingType = LadingType;
}
